import { columnAccountingConnectionStatus } from "commonComponents/utilities/Grid/common/columnImplementations/columnAccountingEntityConnectionStatus";
import { columnArea } from "commonComponents/utilities/Grid/common/columnImplementations/columnArea";
import { columnBillPurchaseOrderLink } from "commonComponents/utilities/Grid/common/columnImplementations/columnBillPurchaseOrderLink";
import { columnCheckbox } from "commonComponents/utilities/Grid/common/columnImplementations/columnCheckbox";
import {
    columnCurrency,
    columnCurrencyAccounting,
} from "commonComponents/utilities/Grid/common/columnImplementations/columnCurrency";
import { columnCurrencyLimit } from "commonComponents/utilities/Grid/common/columnImplementations/columnCurrencyLimit";
import { columnCurrencyVariableScale } from "commonComponents/utilities/Grid/common/columnImplementations/columnCurrencyVariableScale";
import { columnDangerousHTML } from "commonComponents/utilities/Grid/common/columnImplementations/columnDangerousHTML";
import { columnDate } from "commonComponents/utilities/Grid/common/columnImplementations/columnDate";
import { columnDateTime } from "commonComponents/utilities/Grid/common/columnImplementations/columnDateTime";
import { columnDiscussion } from "commonComponents/utilities/Grid/common/columnImplementations/columnDiscussion";
import { columnDiscussionLarge } from "commonComponents/utilities/Grid/common/columnImplementations/columnDiscussionLarge";
import { columnDueDate } from "commonComponents/utilities/Grid/common/columnImplementations/columnDueDate";
import { columnEntityMappingStatus } from "commonComponents/utilities/Grid/common/columnImplementations/columnEntityMappingStatus";
import { columnFileIconLink } from "commonComponents/utilities/Grid/common/columnImplementations/columnFileIconLink";
import { columnFiles } from "commonComponents/utilities/Grid/common/columnImplementations/columnFiles";
import { columnNumber } from "commonComponents/utilities/Grid/common/columnImplementations/columnNumber";
import { columnPercentage } from "commonComponents/utilities/Grid/common/columnImplementations/columnPercentage";
import { columnPercentInvoiced } from "commonComponents/utilities/Grid/common/columnImplementations/columnPercentInvoiced";
import { columnPhone } from "commonComponents/utilities/Grid/common/columnImplementations/columnPhoneNumber";
import { columnRelatedItems } from "commonComponents/utilities/Grid/common/columnImplementations/columnRelatedItems";
import { columnRelatedOwnerInvoices } from "commonComponents/utilities/Grid/common/columnImplementations/columnRelatedOwnerInvoices";
import { columnRfi } from "commonComponents/utilities/Grid/common/columnImplementations/columnRFI";
import { columnSelect } from "commonComponents/utilities/Grid/common/columnImplementations/columnSelect";
import { columnSelectUser } from "commonComponents/utilities/Grid/common/columnImplementations/columnSelectUser";
import { columnSingleLineAddress } from "commonComponents/utilities/Grid/common/columnImplementations/columnSingleLineAddress";
import { columnTags } from "commonComponents/utilities/Grid/common/columnImplementations/columnTags";
import { columnText } from "commonComponents/utilities/Grid/common/columnImplementations/columnText";
import { columnTextList } from "commonComponents/utilities/Grid/common/columnImplementations/columnTextList";
import { columnTime } from "commonComponents/utilities/Grid/common/columnImplementations/columnTime";
import { columnUnitCost } from "commonComponents/utilities/Grid/common/columnImplementations/columnUnitCost";
import { columnURL } from "commonComponents/utilities/Grid/common/columnImplementations/columnURL";
import { columnUser } from "commonComponents/utilities/Grid/common/columnImplementations/columnUser";
import { columnUsers } from "commonComponents/utilities/Grid/common/columnImplementations/columnUsers";
import { type IClientGridColumn } from "commonComponents/utilities/Grid/GridContainer.types";

// todo put in enum order
export const standardColumnImplementations: IClientGridColumn<any>[] = [
    columnDangerousHTML,
    columnText,
    columnTextList,
    columnNumber,
    columnCurrency,
    columnCurrencyAccounting,
    columnCurrencyLimit,
    columnCurrencyVariableScale,
    columnPercentage,
    columnPercentInvoiced,
    columnDate,
    columnTime,
    columnDateTime,
    columnPhone,
    columnURL,
    columnDiscussion,
    columnDiscussionLarge,
    columnDueDate,
    columnFiles,
    columnRfi,
    columnSelect,
    columnSelectUser,
    columnTags,
    columnCheckbox,
    columnFileIconLink,
    columnAccountingConnectionStatus,
    columnSingleLineAddress,
    columnUnitCost,
    columnArea,
    columnEntityMappingStatus,
    columnBillPurchaseOrderLink,
    columnRelatedOwnerInvoices,
    columnRelatedItems,
    columnUser,
    columnUsers,
];
